// extracted by mini-css-extract-plugin
export var iomSkeletonWrapper = "VerificationOptionSkeleton-module--iomSkeletonWrapper--2c01e";
export var verifyButtonSkeleton = "VerificationOptionSkeleton-module--verifyButtonSkeleton--be8ca";